module.exports=function(scope){ return `curl -X POST \
'https://your.internal.facetec.standard.server.instance.url/create-facemap-from-single-image' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE' \
-H 'content-type: application/json' \
-d '{
  "image": INSERT_IMAGE_DATA_AS_BASE64_HERE
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/bash/facemap-post.bash.tpl